<template>
    <section class="signature">
        <div class="content">
          <p><strong>Jeg bekræfter at jeg har læst og accepterer medlemskabsbetingelserne.</strong></p>

          <p>Skriv under med fingeren i den hvide boks herunder og tryk Gem underskrift.</p>
        </div>

      <VueSignaturePad height="500px" ref="signaturePad" class="signature-pad has-background-white" :options="signatureOptions">Test</VueSignaturePad>

        <div class="level has-margin-top-large">
          <div class="level-left">
            <div class="level-item">
              <button class="button is-dark is-large" @click="undo">Fortryd</button>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button class="button is-success is-large" @click="save" :class="{'is-loading': loading}">Gem underskrift</button>
            </div>
          </div>
        </div>
    </section>
</template>

<script>
import {VueSignaturePad} from 'vue-signature-pad'
export default {
  components: {
    VueSignaturePad
  },
    props: {
        customer: { type: Object, required: true },
        subscription: { type: Object, required: true },
    },

    data() {
        return {
          loading: false,
        }
    },
    methods: {
        save(){
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

          if(isEmpty){
            alert('Du skal lave en underskrift for at kunne gemme')
            return
          }

          this.loading = true

          this.$http
              .post(window.location.pathname, {
                signature: data,
                subscription: this.subscription.id
              })
              .then(response => {
                window.location = response.data.data.url
              })
              .catch(error => {
                this.loading = false
                this.error = (error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Der er sket en fejl. Prøv igen.')
              })
        },
      undo(){
        this.$refs.signaturePad.undoSignature()
      }
    },
  computed:{
    signatureOptions(){
      return {
        velocityFilterWeight: 2,
        minWidth: 2
      }
    }
  }
}
</script>

<style lang="scss">
.signature {
  padding-bottom:30px;

  .signature-pad {
    border: 2px solid #ccc;
    border-radius: 10px;
  }
}

</style>